class CountdownTimer extends HTMLElement {
    connectedCallback() {
        const countdownDate = this.dataset.countdownDate;
        if (!countdownDate) return;

        this.targetDate = new Date(countdownDate.replace(' ', 'T')).getTime();
        this.days = this.querySelector('[data-unit="days"]');
        this.hours = this.querySelector('[data-unit="hours"]');
        this.minutes = this.querySelector('[data-unit="minutes"]');
        this.seconds = this.querySelector('[data-unit="seconds"]');

        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
        clearInterval(this.interval);
    }

    tick() {
        if (!this.targetDate) return;
        const distance = this.targetDate - Date.now();

        if (distance <= 0) {
            clearInterval(this.interval);
            this.setUnits(0, 0, 0, 0);
            // Hide rather than sit at 00:00:00:00. Nothing listened for this
            // event, so an expired timer stayed on screen indefinitely.
            this.hidden = true;
            this.dispatchEvent(new CustomEvent('countdown:complete', { bubbles: true }));
            return;
        }

        const d = Math.floor(distance / (1000 * 60 * 60 * 24));
        const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((distance % (1000 * 60)) / 1000);

        this.setUnits(d, h, m, s);
    }

    /**
     * @param {number} d
     * @param {number} h
     * @param {number} m
     * @param {number} s
     */
    setUnits(d, h, m, s) {
        if (this.days) this.days.textContent = String(d).padStart(2, '0');
        if (this.hours) this.hours.textContent = String(h).padStart(2, '0');
        if (this.minutes) this.minutes.textContent = String(m).padStart(2, '0');
        if (this.seconds) this.seconds.textContent = String(s).padStart(2, '0');
    }
}

customElements.define('countdown-timer', CountdownTimer);